import gql from 'graphql-tag';

import listSettingFragment from '../fragments/listSettingFragment';

export const queryListSettings = gql`
  query listSettings {
    listSettings {
      ...listSettingFragment
    }
  }
  ${listSettingFragment}
`;
export default queryListSettings;
